import { baseResources, baseResourceActions } from "routes/enum";

const { CUSTOM_TICKET_STATUS } = baseResources;
const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

/** View custom ticket statuses */
export const CUSTOM_TICKET_STATUS_READ_PERMISSION = [
    `${READ}_${CUSTOM_TICKET_STATUS}`,
];

/** Create custom ticket status */
export const CUSTOM_TICKET_STATUS_CREATE_PERMISSION = [
    `${CREATE}_${CUSTOM_TICKET_STATUS}`,
];

/** Edit custom ticket status (name, description, active toggle) */
export const CUSTOM_TICKET_STATUS_UPDATE_PERMISSION = [
    `${UPDATE}_${CUSTOM_TICKET_STATUS}`,
];

/** Delete custom ticket status */
export const CUSTOM_TICKET_STATUS_DELETE_PERMISSION = [
    `${DELETE}_${CUSTOM_TICKET_STATUS}`,
];

export const CUSTOM_TICKET_STATUS_WRITE_PERMISSION = [
    ...CUSTOM_TICKET_STATUS_CREATE_PERMISSION,
    ...CUSTOM_TICKET_STATUS_UPDATE_PERMISSION,
];

export const CUSTOM_TICKET_STATUS_PERMISSION_MAP = {
    "View custom ticket statuses": CUSTOM_TICKET_STATUS_READ_PERMISSION,
    "Create custom ticket status": CUSTOM_TICKET_STATUS_CREATE_PERMISSION,
    "Edit custom ticket status": CUSTOM_TICKET_STATUS_UPDATE_PERMISSION,
    "Delete custom ticket status": CUSTOM_TICKET_STATUS_DELETE_PERMISSION,
};
